module.exports = __webpack_public_path__ + "img/bg1.2e9f1c95.png";